<div class="tw-flex tw-flex-col tw-gap-2" (click)="handleCardClick()">
  <div class="tw-relative tw-rounded-3 tw-overflow-hidden">
    <video #videoEl class="tw-block tw-w-full tw-aspect-ai-analysis-video-card" playsinline autoplay muted loop
           preload="auto" aria-label="ai analysis"
           [class.tw-invisible]="!isVideoReady()">
      <source [src]="detectionVideo()" type="video/mp4">
    </video>
    @if (!isVideoReady()) {
      <div class="shimmer tw-absolute tw-inset-0 tw-rounded-3"></div>
    }
    <span class="tw-absolute tw-left-1.5 tw-top-2.5 tw-isolate tw-inline-flex apply-container before:tw-rounded-full before:tw-absolute before:tw-inset-0 before:tw-z-[-1] before:tw-p-[2px]">
      <div class="complete-profile-pill tw-flex tw-h-6 tw-w-20 tw-items-center tw-justify-center tw-gap-1 tw-m-0.5 tw-rounded-full">
        <img class="tw-w-3.5 tw-h-3.5" [src]="aiAnalysisIcon" alt="">
        <p class="tw-text-50 tw-leading-4 tw-text-white tw-uppercase tw-font-bold tw-font-body tw-tracking-wide tw-m-0" i18n="@@cureAi">Cure AI</p>
      </div>
    </span>
  </div>

  <button csButton
          id="rcyp-analyse-cta"
          data-testid="home-analyse-skin"
          type="button"
          class="shine loop tw-w-full tw-py-2 tw-gap-2 tw-text-400 tw-font-semibold tw-h-fit tw-max-w-none">
    @if (isFace()) {
      <span i18n="@@analyseYourSkinNow">Analyse Your Skin Now</span>
    } @else {
      <span i18n="@@analyseYourHairNow">Analyse Your Hair Now</span>
    }
    <span class="cs-icon-camera tw-text-400 tw-mt-0.5"></span>
  </button>
</div>
